import type { WorkStep } from "@studio/shared";
import { apiRequest } from "../lib/api";
import { navigate } from "../lib/navigation";
import { pathForStep } from "../lib/session";

/** 포스터 단계 표시줄 칸(1~4) ↔ 서버 단계 */
export const POSTER_STEP_BY_NUMBER: Record<1 | 2 | 3 | 4, Extract<WorkStep, `pst_${string}`>> = {
  1: "pst_draw",
  2: "pst_edit",
  3: "pst_song",
  4: "pst_done",
};

export function posterStepPath(workId: string, step: 1 | 2 | 3 | 4): string {
  return pathForStep(workId, POSTER_STEP_BY_NUMBER[step]);
}

/**
 * 단계를 옮긴다 — 서버 단계도 같이 적어 «다른 컴퓨터에서 들어와도 그 칸에서» 이어지게 한다.
 * 🔑 4단계(인쇄 확정 화면)는 서버 단계를 바꾸지 않는다 — `pst_done` 은 확정이 넘긴다(routes/work.ts).
 */
export async function goPosterStep(workId: string, step: 1 | 2 | 3 | 4): Promise<void> {
  if (step !== 4) {
    await apiRequest(`/api/works/${encodeURIComponent(workId)}/autosave`, {
      method: "POST",
      body: JSON.stringify({ step: POSTER_STEP_BY_NUMBER[step], gifts_v: 2 }),
    });
  }
  navigate(posterStepPath(workId, step));
}
